import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import BankTransferDetailViewModel from "viewModels/finance/outgoingPayments/bankTransferDetailViewModel";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay/index";
import Col from "react-bootstrap/Col";
import { NavigationFooter } from "views/common/navigationFooter";
import RefundChargeSection from "../refundChargeSection";
import { Modal, Row } from "react-bootstrap";
import OutgoingBankTransferPaymentSection from "./outgoingBankTransferPaymentSection";
import OriginalBankTransferPaymentSection from "./originalBankTransferPaymentSection";

const BankTransferDetailView: ViewComponent<BankTransferDetailViewModel> = observer(({ vm }) => {
  return (
    <Modal scrollable show={true} onHide={vm.requestClose} centered dialogClassName="modal-90w">
      <Modal.Header closeButton={true}>
        <div className="d-flex align-items-center justify-content-start">
          <h3 className="mb-0">{vm.translate("outgoingPaymentTitle")}</h3>
        </div>
      </Modal.Header>
      <Modal.Body>
        <LoaderOverlay loading={vm.busyWatcher.isBusy}>
          {!vm.isInitialized || !vm.item ? (
            <div style={{ minHeight: "100px" }} />
          ) : (
            <Row>
              <Col xs={12} className="mb-4">
                <RefundChargeSection vm={vm} />
              </Col>
              <Col lg={12} xl={5} className="mb-4 mb-xl-0">
                <OriginalBankTransferPaymentSection vm={vm} />
              </Col>
              <Col lg={12} xl={7}>
                <OutgoingBankTransferPaymentSection vm={vm} />
              </Col>
            </Row>
          )}
        </LoaderOverlay>
      </Modal.Body>
      <Modal.Footer style={{ minHeight: "100px" }}>
        <NavigationFooter vm={vm} />
      </Modal.Footer>
    </Modal>
  );
});

registerView(BankTransferDetailView, BankTransferDetailViewModel);
